import { css } from "styled-components";

import theme from "../../styles/theme";

export default css`
  cursor: pointer;
  border-radius: 4px;
  border: none;
  padding: 2px 16px;
  font-family: 'Graphik', 'Graphik Web', 'Helvetica Neue',Helvetica,Arial,sans-serif;
  transition: ${() => theme.motion.short};
  background-color: ${() => theme.colors.green5};
  &:hover {
    background-color: ${() => theme.colors.green4};
  }
  ${() => theme.media.desktopUp`
    padding: 2px 36px;
    width: auto;
  `}
`;
